export const MESH_ID_SEPARATOR = '$'
export const skinPartId = 'inlineContent'
export const POSITION_ABSOLUTE_IN_MESH = ['AppController', 'Popover']
